import { IconName } from 'components/_core/SunshineIcon';

import * as Types from '../../../../__generated__/GQL';
import { Device } from '../../types';

export const getIconName = (device: Device): IconName => {
  if (device.status === Types.AuthenticationDeviceStatus.Blocked) {
    return 'forbidden';
  }
  if (
    device.platform === Types.AuthenticationDevicePlatform.Android ||
    device.platform === Types.AuthenticationDevicePlatform.Ios
  ) {
    return 'mobile';
  }

  if (device.platform === Types.AuthenticationDevicePlatform.Web) {
    return 'laptop';
  }

  return 'question';
};
